// extracted by mini-css-extract-plugin
module.exports = {"qsButton":"KBDPd","qsButtonPrimary":"_33wQ+","iconTextWrapper":"Iw1X4"};